    const helpHubContent = {
      categories: [
        { title: 'FAQs', url: '/pages/faq' },
        { title: 'Returns & Exchanges', url: '/pages/returns-exchanges' },
        { title: 'Shipping', url: '/pages/shipping' },
        { title: 'General', url: '/pages/faq' },
        { title: 'Order Amendments', url: '/pages/returns-exchanges' },
        { title: 'Order Issues', url: '/pages/returns-exchanges' },
        { title: 'Product & Sizing', url: '/pages/find-your-perfect-size-guide' },
        { title: 'Payment & Gift Cards', url: '/pages/payment-gift-cards' },
        { title: 'Contact Support', url: '/pages/contact-info' },
        { title: 'Rewards Program', url: '/pages/rewards', category: 'Programs' },
        { title: 'Affiliates & Creators', url: '/pages/affiliates-and-creators', category: 'Programs' },
        { title: 'About Our Store', url: '/pages/about-our-store', category: 'About' }
      ],
      popularFaqs: [
        { title: 'Shipping Times', url: '/pages/shipping' },
        { title: 'Returns Policy', url: '/pages/returns-policy' },
        { title: 'Your LITE Fit', url: '/pages/find-your-perfect-size-guide' },
        { title: 'Rewards Program', url: '/pages/rewards' },
        { title: 'Become an Affiliate', url: '/pages/affiliates-and-creators' }
      ]
    };

    document.addEventListener('DOMContentLoaded', function() {
      const searchInput = document.querySelector('input[placeholder="Search FAQs..."]');
      if (!searchInput) return;
      
      const searchWrapper = document.createElement('div');
      searchWrapper.style.position = 'relative';
      
      searchInput.parentNode.insertBefore(searchWrapper, searchInput);
      searchWrapper.appendChild(searchInput);
      
      const searchResultsContainer = document.createElement('div');
      searchResultsContainer.id = 'search-results';
      searchResultsContainer.style.cssText = `
        display: none;
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: white;
        border: 1px solid #ccc;
        border-radius: 5px;
        max-height: 300px;
        overflow-y: auto;
        z-index: 1000;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      `;
      searchWrapper.appendChild(searchResultsContainer);

      searchInput.addEventListener('input', function(e) {
        const searchTerm = e.target.value.toLowerCase();
        
        if (searchTerm.length < 2) {
          searchResultsContainer.style.display = 'none';
          return;
        }

        const results = helpHubContent.categories
          .filter(item => item.title.toLowerCase().includes(searchTerm));
        
        if (results.length > 0) {
          searchResultsContainer.style.display = 'block';
          
          const groupedResults = results.reduce((acc, item) => {
            const category = item.category || 'General';
            if (!acc[category]) {
              acc[category] = [];
            }
            acc[category].push(item);
            return acc;
          }, {});

          searchResultsContainer.innerHTML = Object.entries(groupedResults)
            .map(([category, items]) => `
              <div class="search-category">
                <div style="padding: 8px 10px; background: #f5f5f5; font-weight: bold; color: #666;">
                  ${category}
                </div>
                ${items.map(item => `
                  <a href="${item.url}" 
                     style="display: block; 
                            padding: 10px; 
                            text-decoration: none; 
                            color: #333; 
                            border-bottom: 1px solid #eee;
                            transition: background-color 0.2s;">
                    ${item.title}
                  </a>
                `).join('')}
              </div>
            `).join('');
        } else {
          searchResultsContainer.innerHTML = `
            <div style="padding: 10px; color: #666;">
              No results found for "${searchTerm}"
            </div>`;
        }
      });

      document.addEventListener('click', function(e) {
        if (!searchWrapper.contains(e.target)) {
          searchResultsContainer.style.display = 'none';
        }
      });
    });
